import React, { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { LineChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis, BarChart, Bar, CartesianGrid } from "recharts";

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(({ data }) => setD(data)); }, []);
  if (!d) return <div>Loading...</div>;
  const cards = [
    { l: "Total revenue", v: money(d.total_revenue), t: "revenue" },
    { l: "Total sales", v: d.total_sales, t: "sales" },
    { l: "Total students", v: d.total_students, t: "students" },
    { l: "Active courses", v: d.active_courses, t: "courses" },
    { l: "Active offers", v: d.active_offers, t: "offers" },
    { l: "Today revenue", v: money(d.today_revenue), t: "today" },
    { l: "This month", v: money(d.month_revenue), t: "month" },
    { l: "Avg order value", v: money(d.avg_order), t: "aov" },
  ];
  return (
    <div className="space-y-10" data-testid="admin-dashboard">
      <div>
        <div className="overline mb-2">Dashboard</div>
        <h1 className="font-display text-4xl font-black tracking-tighter">Business overview</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div key={c.t} className="glass rounded-xl p-5" data-testid={`kpi-${c.t}`}>
            <div className="overline mb-2">{c.l}</div>
            <div className="font-display text-2xl font-bold">{c.v}</div>
          </div>
        ))}
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="glass rounded-xl p-6">
          <div className="overline mb-4">Revenue (last 14 days)</div>
          <ResponsiveContainer width="100%" height={240}>
            <LineChart data={d.revenue_by_day}><CartesianGrid stroke="rgba(63,46,36,0.08)" /><XAxis dataKey="date" tick={{ fill: "#6E594A", fontSize: 10 }} /><YAxis tick={{ fill: "#6E594A", fontSize: 10 }} /><Tooltip contentStyle={{ background: "#FBF7EE", border: "1px solid #E2D6BB", color: "#231810" }} /><Line dataKey="revenue" stroke="#B8894B" strokeWidth={2} dot={false} /></LineChart>
          </ResponsiveContainer>
        </div>
        <div className="glass rounded-xl p-6">
          <div className="overline mb-4">Revenue by course</div>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={d.revenue_by_course}><CartesianGrid stroke="rgba(63,46,36,0.08)" /><XAxis dataKey="title" tick={{ fill: "#6E594A", fontSize: 10 }} /><YAxis tick={{ fill: "#6E594A", fontSize: 10 }} /><Tooltip contentStyle={{ background: "#FBF7EE", border: "1px solid #E2D6BB", color: "#231810" }} /><Bar dataKey="revenue" fill="#B8894B" /></BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
